import React, { useState,useEffect } from "react";
import "./WorkflowTab.css";
import WorkflowMapping from "../Tab Content/Workflow Mapping";
import WorkflowTemplate from "../Tab Content/Workflow Template";
import SubflowTemplate from "../Tab Content/Subflow Template";
import { ReactFlowProvider } from "reactflow";
import Events from "../Tab Content/Events";
import EventTab from "./EventTab";
import Tasks from "../Tab Content/Tasks";
import WorkflowTransaction from "../Tab Content/Workflow Transaction";
import { useLocation, useNavigate } from "react-router-dom";

import WorkflowTemplateServiceController from '../../Controllers/WorkflowTemplateservice';

const workflowTempcont = new WorkflowTemplateServiceController();

const WorkflowTab = ({selectedIndex}) => {
   const navigate = useNavigate();   // ✅ correct
  const { state } = useLocation();  // ✅ correct
  const [workflowMappingToolTipData, setWorkflowMappingToolTipData] = useState([]);
  const [workflowToolTipData, setWorkflowToolTipData] = useState([]);
  const [subflowToolTipData, setSubflowToolTipData] = useState([]);
  const [eventToolTipData, setEventToolTipData] = useState([]);
  const [taskToolTipData, setTaskToolTipData] = useState([]);

  const [workflowMgmt,setWorkflowMgmt] = useState(false);
  const [activeTab, setActiveTab] = useState(0);
  const [isCanvas, setIsCanvas] = useState(false);
  const [json, setJson] = useState({"nodes":[], "edges":[],"dropdownData": {
      "client": "--select--",
      "department": "--select--",
      "workflowName": "--select--",
      "level":"--select--"
    }});
  const [isSubflow,setIsSubflow] =useState(false);
  const [inWorkflow,setInWorkflow] =useState(true);
  const workflowMgmtTabList = ['Workflow Mapping','Workflow Templates','Subflow Templates','Events'];
  const workflowInstTabList = ['Workflow Transactions'];
  const [transaction, setTransaction] = useState(true);
    

  const fetchToolTipData = async () => {  
    const toolTipData = await workflowTempcont.getEachTabToolTipDetail();
    const workflowMapTips = [];
    const workflowTips = [];
    const subflowTips = [];
    const eventTips = [];
    const taskTips = [];
  
    toolTipData.forEach(item => {
      const tipObject = {
        content: item.tipContent,
        sequence: item.subTabSequence
      };
  
 
      if (item.tabId === 1 && item.subTabId === 1) {
        workflowMapTips.push(tipObject);
      } else if (item.tabId === 1 && item.subTabId === 2) {
        workflowTips.push(tipObject);
      } else if (item.tabId === 1 && item.subTabId === 3) {
        subflowTips.push(tipObject);
      } else if (item.tabId === 1 && item.subTabId === 4) {
        eventTips.push(tipObject);
      } else if (item.tabId === 1 && item.subTabId === 5) {
        taskTips.push(tipObject);
      }
    });
  
    // Sort each group by subTabSequence
    const sortBySequence = arr => arr.sort((a, b) => a.sequence - b.sequence).map(item => item.content);
    setWorkflowMappingToolTipData(sortBySequence(workflowMapTips));
    setWorkflowToolTipData(sortBySequence(workflowTips));
    setSubflowToolTipData(sortBySequence(subflowTips));
    setEventToolTipData(sortBySequence(eventTips));
    setTaskToolTipData(sortBySequence(taskTips));

  };
  

    useEffect(()=>{
    
      fetchToolTipData();
    },[]);
 

  const handleClick = (index) => {
    setActiveTab(index);
   // Clear edit mode when switching tabs
   navigate(".", { replace: true, state: null });
    if(index === 1 || (index === 0))
      setIsSubflow(false);
    setJson({
      "nodes":[],
       "edges":[],
       "dropdownData":{
      "client": { label: "--select--", value: "--select--", dropdownId: "0" },
      "department": { label: "--select--", value: "--select--", dropdownId: "0" },
      "workflowName":{ label: "--select--", value: "--select--", dropdownId: "0" },
      "level":{ label: "--select--", value: "--select--", dropdownId: "0" },
    }});
  setIsCanvas(false);
  setFromEventToTask(false);
  };

  useEffect(() => {
   if(selectedIndex !== '4'){
    setWorkflowMgmt(true);
   }
  }, [selectedIndex]);
  const [editEventFromSubflow,setEditEventFromSubflow]  =useState(false);
  const [editEventDetails,setEditEventDetails] = useState({});
  const [fromEventToTask,setFromEventToTask] = useState(false);
 //Function called from workflow canvas(used for passing data from subflow node)
const handleSubflowCanvasClick=(level, index, isEditSubflow,json,bool, transaction,eventDetails)=>{
  // Setting various parameter to the below tabs
  setEditEventFromSubflow(true);
  setEditEventDetails(eventDetails);
  setActiveTab(index);
  // setIsCanvas(isEditSubflow);
  // setJson(json);
  // setIsSubflow(bool);
  // setTransaction(transaction);
  // setInWorkflow(false);

}
const createEventOrTask=(changeIndex)=>{
handleClick(changeIndex);
if(changeIndex === 3) setFromEventToTask(true)
}
  return (
    <>
      <div className="tabContainer">
        {
          workflowMgmt ?
          <ul className="tabs">
          { workflowMgmtTabList.map((tab,index) =>(
              <li key={index}
              className={activeTab === index ? "active" : ""}
              onClick={() => {
                handleClick(index);
              }}
            >
          {tab}
            </li>
           ))}           
         </ul>:
               <ul className="tabs">
               { workflowInstTabList.map((tab,index) =>(
                   <li key={index}
                   className={activeTab === index ? "active" : ""}
                   onClick={() => {
                     handleClick(index);
                   }}
                 >
               {tab}
                 </li>
                ))}
              </ul>

        }
  
      </div>
      {/* Based on the Selected index variable workflowMgmt is managed and content of each menu is decided */}
     {
    workflowMgmt ?
      <div className="tabContent">
      {activeTab === 0 && <ReactFlowProvider><WorkflowMapping isSubflow={isSubflow} Json={json} toolTipData={workflowMappingToolTipData}/> </ReactFlowProvider>}
      {activeTab === 1 && <ReactFlowProvider><WorkflowTemplate handleSubflowCanvasClick={handleSubflowCanvasClick} isSubflow={isSubflow} Json={json} createEvent={null} toolTipData={workflowToolTipData}/> </ReactFlowProvider>}
      {activeTab === 2 && <ReactFlowProvider><SubflowTemplate isCanvas={isCanvas} json={json} isSubflow={isSubflow} handleSubflowCanvasClick={handleSubflowCanvasClick} createEvent={createEventOrTask} toolTipData={subflowToolTipData}/></ReactFlowProvider>}
      {activeTab === 3 && <EventTab editEventFromSubflow={editEventFromSubflow} eventDetails={editEventDetails} createTask={createEventOrTask} toolTipData={eventToolTipData}/>}
      {activeTab === 4 && <Tasks fromEvent={fromEventToTask} toolTipData={taskToolTipData}/>}
    </div>:
       <div className="tabContent">
       {activeTab === 0 && <ReactFlowProvider><WorkflowTransaction isSubflow={isSubflow} handleSubflowCanvasClick={handleSubflowCanvasClick} isTransaction={transaction} workflow ={inWorkflow} /></ReactFlowProvider>}
     </div>
     } 
   
    </>
  );
};

export default WorkflowTab;
